export const ACTION_TYPE_PLACES_FETCHED   = 'PLACES_FETCHED'
export const ACTION_TYPE_PLACES_FETCHING  = 'PLACES_FETCHING' 